import ImageS7 from '../../../assets/images/s7.png'
import Mockup from '../../../assets/images/s7_mockup.png'
import Tool from '../../../assets/images/s7_tool.png'

const Section7 = () => {
    return (
        <div className="w-full md:h-screen grid grid-cols-1 md:grid-cols-2 pt-20 md:pt-0">
            <div className="w-full flex flex-col items-start justify-center gap-3 relative pr-10  pl-5 mdpl-10 text-sm md:text-base">
                <h1 className="text-3xl md:text-5xl font-bold text-custom-green">Our Best Services</h1>
                <p className="text-justify pb-5">
                    Di Kebun Jitu, kami berkomitmen untuk memberdayakan petani hortikultura lokal dengan alat dan pengetahuan yang mereka butuhkan untuk berkembang. Layanan kami dirancang untuk meningkatkan produktivitas, mengoptimalkan kesehatan tanah, dan mendukung praktik pertanian berkelanjutan.
                </p>
                <div className='w-full flex items-center justify-between bg-custom-green text-white p-3 rounded-xl'>
                    <p className='text-center'>
                        Instant Portable Soil Analysis Data-Driven Recommendations
                    </p>
                    <img src={Mockup} alt="Kebun Jitu" className='h-[100px] object-contain' loading='lazy' />
                </div>
                <div className='w-full flex items-center justify-between bg-custom-green text-white p-3 rounded-xl'>
                    <p className='text-center'>
                        Instant Portable Soil Analysis Data-Driven Recommendations
                    </p>
                    <img src={Tool} alt="Kebun Jitu" className='h-[100px] object-contain' loading='lazy' />
                </div>
            </div>
            <div className='w-full md:h-screen pt-5 md:pt-0'>
                <img src={ImageS7} alt="Kebun Jitu" className='w-full h-[300px] md:h-full object-cover' loading='lazy' />
            </div>
        </div>
    )
}

export default Section7